export var HEADER_NAVIGATION_LINKS_CLASS_PREFIX = 'HeaderNavigationLinks';
export var headerNavigationLinksRoot = 'HeaderNavigationLinksRoot';